module.exports = __webpack_public_path__ + "img/about_elaine.d0456378.png";